import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';

const AdminShell: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin');
  };

  return (
    <div className="admin-shell">
      <aside className="admin-shell-sidebar" aria-label="Admin navigation">
        <div className="admin-shell-brand">
          <span className="admin-shell-logo">
            EURO<span>JDM</span>
          </span>
          <span className="admin-shell-badge">Console</span>
        </div>
        <nav className="admin-shell-nav">
          <NavLink
            to="/admin/dashboard"
            className={({ isActive }) => `admin-shell-link ${isActive ? 'active' : ''}`}
            end
          >
            <span className="admin-shell-link-icon" aria-hidden>
              ≡
            </span>
            Inventory
          </NavLink>
          <NavLink
            to="/admin/settings"
            className={({ isActive }) => `admin-shell-link ${isActive ? 'active' : ''}`}
          >
            <span className="admin-shell-link-icon" aria-hidden>
              ◎
            </span>
            Settings
          </NavLink>
        </nav>
        <div className="admin-shell-sidebar-footer">
          <p className="admin-shell-hint">Local session · refresh clears auth</p>
        </div>
      </aside>

      <div className="admin-shell-main">
        <header className="admin-shell-top">
          <div className="admin-shell-top-inner">
            <h1 className="admin-shell-title">Admin</h1>
            <div className="admin-shell-top-actions">
              <a
                href="/"
                className="admin-shell-ghost-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                View site
              </a>
              <button type="button" className="admin-shell-logout" onClick={handleLogout}>
                Sign out
              </button>
            </div>
          </div>
        </header>
        <div className="admin-shell-outlet">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminShell;
